import React, { useState } from 'react';

const perks = [
  { title: 'Premium Deals',  desc: 'Partnerships at rates that reflect your true value' },
  { title: 'Brand Fit',      desc: 'Only brands that genuinely align with your content' },
  { title: 'Full Support',   desc: 'We handle negotiation, contracts, and briefs for you' },
  { title: 'Growth Focus',   desc: 'We look out for your long-term brand, not just one deal' },
];

export default function ForCreators() {
  const [ctaHover, setCtaHover] = useState(false);

  return (
    <section id="creators" className="section-pad" style={{ padding: '120px 56px', background: 'var(--white)', borderTop: '1px solid var(--border)' }}>
      <div className="section-grid-2" style={{ maxWidth: '1280px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}>

        {/* Quote card */}
        <div style={{ background: 'var(--hero-bg)', padding: '52px 44px', borderRadius: '4px' }}>
          <div style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(24px, 2.5vw, 36px)', fontWeight: 700, color: 'var(--white)', lineHeight: 1.35, marginBottom: '28px', fontStyle: 'italic' }}>
            "Your audience is your greatest asset. We help you monetize it without compromising it."
          </div>
          <div style={{ width: '40px', height: '3px', background: 'var(--accent)', marginBottom: '20px', borderRadius: '2px' }} />
          <div style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'rgba(255,255,255,0.55)', lineHeight: 1.8 }}>
            We work with creators at every level — from rising voices to established names — with the same care and professionalism.
          </div>
        </div>

        {/* Content */}
        <div>
          <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '20px' }}>
            For Creators
          </div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(32px, 4vw, 56px)', fontWeight: 900, lineHeight: 1, color: 'var(--ink)', marginBottom: '28px', textTransform: 'uppercase', letterSpacing: '-0.02em' }}>
            Turn Your<br />Audience Into<br />Real Income
          </h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '15px', fontWeight: 400, color: 'var(--ink-muted)', lineHeight: 1.8, marginBottom: '36px' }}>
            Niles Ascend matches you with brands that align authentically with your content and negotiates deals that respect your value — so you can stay focused on creating.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1px', background: 'var(--border)', border: '1px solid var(--border)', marginBottom: '40px' }}>
            {perks.map((p, i) => (
              <div key={i} style={{ padding: '20px', background: 'var(--white)' }}>
                <div style={{ fontFamily: 'var(--font-body)', fontSize: '13px', fontWeight: 700, color: 'var(--ink)', marginBottom: '6px' }}>{p.title}</div>
                <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 400, color: 'var(--ink-muted)', lineHeight: 1.6 }}>{p.desc}</div>
              </div>
            ))}
          </div>

          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: '13px',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              padding: '14px 36px',
              background: ctaHover ? 'var(--accent-dark)' : 'var(--accent)',
              color: '#0a0a0a',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
            onMouseEnter={() => setCtaHover(true)}
            onMouseLeave={() => setCtaHover(false)}
          >
            Join Our Network →
          </button>
        </div>
      </div>
    </section>
  );
}
